import { createAction, props } from '@ngrx/store';

import { Employee, FertilizationLegalStandards } from '../fertilization-legal-standards.models';

export const getFertilizationLegalStandards = createAction(
  '[Fertilization legal standards] Get fertilization legal standards',
);

export const setFertilizationLegalStandards = createAction(
  '[Fertilization legal standards] Set fertilization legal standards',
  props<{ fertilizationLegalStandards: FertilizationLegalStandards }>(),
);

export const getLoggedInEmployee = createAction(
  '[Fertilization legal standards] Get loggedin employee',
);

export const setLoggedInEmployee = createAction(
  '[Fertilization legal standards] Set loggedin employee',
  props<{ employee: Employee }>(),
);
